<div class="action-panel">
  <div>
    <img (click)="cancel()" class="cursor-pointer action-panel__close" src="/assets/close-icon-v3.svg" alt="Close" />
    <span class="fz-14 action-panel__selected-items">
      <ng-container *ngIf="!customText.length; else customTextTempl">
        {{ selectedItems }}
        {{ (selectedItems === 1 ? 'Shared.Entity.Item_selected' : 'Shared.Entity.Items_selected') | translate }}
      </ng-container>
    </span>
  </div>
  <div class="action-panel__buttons-wrapper">
    <div
      *ngIf="!isDownload; else downloadSpinner"
      class="br-8 d-flex align-items-center justify-content-center action-panel__button cursor-pointer"
      [ngClass]="{ 'mr-8': isDownload }"
      [ngbTooltip]="'Shared.Entity.Download' | translate"
      triggers="hover touchstart"
      (click)="download()"
    >
      <img src="/assets/download_white.svg" width="16" height="16" alt="download" />
    </div>
  </div>
</div>

<ng-template #downloadSpinner>
  <div class="br-8 mr-4 d-flex align-items-center justify-content-center action-panel__loader">
    <span class="custom-spinner custom-spinner-17"></span>
  </div>
</ng-template>

<ng-template #customTextTempl>
  {{ selectedItems }}
  {{ (selectedItems === 1 ? customText[0] : customText[1]) | translate }}
</ng-template>
